export const environment = {
    production: false,
    apiUrl: "https://app-02-yllwcore-backend-weu-dev.azurewebsites.net",
    frontEndUrl: "https://core-dev.yllw.com",
    environmentName: "Development",
    ssoClientId: "47b1ffc3-b518-4bd1-917f-f9cb925b01cb",
    enableStoreDevtools: true,
    devtoolsMaxAge: 200,
    devtoolsLogOnly: false,
    signInLoadingTimeMs: 0,
    scopes: {
        read: ["api://6036d8fd-b249-43e0-bd18-fe636f1bdfdd/YllwCore.ReadWrite"],
        write: ["api://6036d8fd-b249-43e0-bd18-fe636f1bdfdd/YllwCore.ReadWrite"],
    },
    InactiveCustomersBCCompanyId: "44f59775-5863-ee11-8def-0022489a2d3f",
    InactiveCustomersBCEnvironment: "yllw_dev",
};
